export default __webpack_public_path__ + "static/media/ALLERGEN_SOYA.c8dddecb.png";